import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { RouteEventsService } from '../../services/url.service';

@Component({
    standalone: true,
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    imports: [MatButtonModule, MatIconModule, MatInputModule],
})
export class BackButtonComponent {
    public previousURL: string;

    @Input() url: string;
    @Input() color = 'primary';

    constructor(
        private _router: Router,
        private routeEventsService: RouteEventsService
    ) {
        this.previousURL = this.routeEventsService.instant_previous_route_path;
    }

    goBack(): void {
        if (this.url) {
            this._router.navigate([this.url]);
        } else {
            if (this.previousURL) {
                this._router.navigate([this.previousURL]);
            }
        }
    }
}
